(function () {
  "use strict";

  const Currency = {
    rates: {
      USD: 1,
      EUR: 1.09598,
      GBP: 1.26944,
      CAD: 0.744461,
      AUD: 0.649994,
      CNY: 0.1384,
      HKD: 0.127901,
      JPY: 0.00690184,
      SGD: 0.739383,
      NZD: 0.598462,
      CHF: 1.1405
    },

    convert(amount, from, to) {
      const sourceRate = this.rates[from];
      const targetRate = this.rates[to];

      if (!Number.isFinite(amount) ||
          !Number.isFinite(sourceRate) ||
          !Number.isFinite(targetRate) ||
          sourceRate <= 0 ||
          targetRate <= 0) {
        throw new Error("Invalid amount or unsupported currency");
      }

      return amount * sourceRate / targetRate;
    }
  };

  window.Currency = Currency;
})();